/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  StyledInputV3,
} from "../CreateEvent/style";

import { AddIconRecognition, closeIcon, CloseIconBranding, PromotionalDocIcon, RecognitionCloseIcon, RemoveIcon, UploadHDMIcon, UploadIconSVG, WeekDropdownIcon } from "../../utils/icons";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";
import { Border } from "../Journeys/styles";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import CommonImageUploader from "../common/CommonImageUploader/CommonImageUploader";
import Editor from "../CKEditor";
import { Main } from "../AdminTeamCreation/styles";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import CommonDropdown from "../common/CommonDropDown/CommonDropdown";
import { RadioButton, RadioButtonWrapper } from "../RecogntionAdmin/styles";
import { ActionButton, AudioUploadBox, MoreOptionText, OptionsContainer, ToggleCircle, ToggleContainer, ToggleWrapper, WeekContainer, WeekWrapper } from "./styles";
import { InputImage, RemoveImageV2, UploadPhotoContainer } from "../common/CommonImageUploader/style";
import { ConvertCsvToJson, EditWellnessChallenge, GetWellnessChallenge } from "../../redux/constants/apiConstants";
import { wellnessChallengePoints } from "../../../mockData";
import { toast } from "react-toastify";
import { deleteFromS3, fetchApi, uploadToS3 } from "../../utils/methods";
import { ImageUrl } from "../../utils/constants";
import Waiting from "../Waiting";
import CSVList from "../PeopleHomeV2/CSVList";
import Spinner from "../common/Spinner";





const sampleData = [
  { week: 1, day: 1, task: "Task 1", video_link: "https://example.com/video1", "goalNotification": "Notification for goal based task", "journalingNotification": "Notification for journaling task", "notCompletedNotification": "Notification for not completed task" },
  { week: 1, day: 2, task: "Task 2", video_link: "https://example.com/video2", "goalNotification": "Notification for goal based task", "journalingNotification": "Notification for journaling task", "notCompletedNotification": "Notification for not completed task" },
  { week: 1, day: 3, task: "Task 3", video_link: "https://example.com/video3", "goalNotification": "Notification for goal based task", "journalingNotification": "Notification for journaling task", "notCompletedNotification": "Notification for not completed task" },
  { week: 1, day: 4, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 5, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 6, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 1, day: 7, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 1, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 2, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 3, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 4, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 5, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 6, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 2, day: 7, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 1, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 2, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 3, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 4, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 5, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 6, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 3, day: 7, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 1, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 2, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 3, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 4, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 5, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 6, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 4, day: 7, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 1, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 2, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
  { week: 5, day: 3, task: "", video_link: "", "goalNotification": "", "journalingNotification": "", "notCompletedNotification": "" },
];



class EditChallengeForm extends Component {
  constructor() {
    super();
    this.csvInputRef = React.createRef();

    this.state = {
      challengeId: null,
      title: "",
      videoTitle: "",
      videoUrl: "",
      challenge_level: null,
      pointValue: "",
      url: "",
      time: "",
      options: ["", ""],
      activeQuestion: 0,
      feedbackActiveQuestion: 0,
      pillarId: null,
      printSampleBiometricCSV: false,
      description: "",
      imageName: "",
      challengePointValue: null,
      challengePointKey: "0 points",
      imgSrc: "",
      selectedValues: [],
      buttonstatus: false,
      loading: false,
      step: 1,
      audio_link: "",
      file: null,
      levelOpen: true,
      fileName: "",
      csvUpload: false,
      step1Updated: false,
      step2Updated: false,
      step3Updated: false,
      step4Updated: false,
      step5Updated: false,
      points: null,
      so: false,
      showBack: false,
      buttonClickScrollTop: false,
      so2: false,
      WellnessChallengeData: null,
      question: "",
      levels: null,
      selectedLinkOption: 0,
      so3: false,
      iseventUrlMsg: "",
      charCount: 0,
      selectedOption: 1,
      selectedCategory: null,
      questions: [
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      feedBackQuestions: [
        { text: "", options: ["", ""], allowMultiple: false },
      ],
      themeId: null,
      active: false,
      expandedWeek: 0, // index of currently expanded week (0-based)


      weeksData: Array.from({ length: 5 }, (_, weekIndex) => {
        const days = weekIndex === 4 ? 3 : 7; // 5th week → 3 days

        return Array.from({ length: days }, () => ({
          task: "",
          video_link: "",
          media_type: "yes-no",
          media_link: "",
          media_thumbnail: "",
          goalNotification: "",
          journalingNotification: "",
          notCompletedNotification: "",
        }));
      })
    };
  }


  componentDidMount() {
    const path = window.location.pathname;
    const challengeId = path.split("/").pop();
    this.setState({ challengeId });
    this.getWellnessChallenge(challengeId);

  }



  getWellnessChallenge = async (challengeId) => {
    const challenge_id = challengeId;
    let apiUrl = GetWellnessChallenge + "/" + challenge_id;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        this.setState({ WellnessChallengeData: res.data });

        let weeksData = Array.from({ length: 5 }, (_, weekIndex) => {
          const days = weekIndex === 4 ? 3 : 7;
          return Array.from({ length: days }, () => ({
            id: null,
            task: "",
            video_link: "",
            media_link: "",
            goalNotification: "",
            journalingNotification: "",
            notCompletedNotification: "",
            media_type: "yes-no"
          }));
        });

        if (res.data?.["step-3"]?.tasks && Array.isArray(res.data?.["step-3"]?.tasks)) {
          res.data?.["step-3"]?.tasks.forEach((task) => {
            const weekIdx = (task.week || 1) - 1; // week 1 → index 0
            const dayIdx = (task.day || 1) - 1;   // day 1 → index 0

            if (weeksData[weekIdx] && weeksData[weekIdx][dayIdx]) {
              weeksData[weekIdx][dayIdx] = {
                id: task.id || null,
                task: task.task || "",
                video_link: task.media_type === "mp4" ? task.media_link || "" : "",
                media_link: task.media_type === "mp3" ? task.media_link || "" : "",
                goalNotification: task.task_goal || "",
                journalingNotification: task.journaling_prompt || "",
                notCompletedNotification: task.not_completed_notification || "",
                media_type: task.media_type || "yes-no"
              };
            }
          });
        }

        let preQuizQuestions = [];
        if (res.data?.["step-4"]?.pre_quiz_questions && Array.isArray(res?.data["step-4"].pre_quiz_questions)) {
          // remove duplicates by question id
          const uniqueQuestions = res?.data["step-4"].pre_quiz_questions.reduce((acc, q) => {
            if (!acc.some((item) => item.id === q.id)) acc.push(q);
            return acc;
          }, []);

          preQuizQuestions = uniqueQuestions.map((q) => ({
            id: q.id,
            text: q.question || "",
            options: q.answers ? q.answers.map((a) => a.answer) : ["", ""],
            allowMultiple: q.allow_multiple_respondents === 1
          }));
        } else {
          // fallback default if no questions
          preQuizQuestions = [
            { text: "", options: ["", ""], allowMultiple: false },
            { text: "", options: ["", ""], allowMultiple: false },
            { text: "", options: ["", ""], allowMultiple: false },
          ];
        }



        // Transform post-quiz questions
        let postQuizQuestions = [];
        if (res?.data?.["step-5"]?.post_quiz_questions && Array.isArray(res?.data["step-5"].post_quiz_questions)) {
          // remove duplicates by question id
          const uniquePostQuestions = res?.data["step-5"].post_quiz_questions.reduce((acc, q) => {
            if (!acc.some((item) => item.id === q.id)) acc.push(q);
            return acc;
          }, []);

          postQuizQuestions = uniquePostQuestions.map((q) => ({
            id: q.id,
            text: q.question || "",
            options: q.answers ? q.answers.map((a) => a.answer) : ["", ""],
            allowMultiple: q.allow_multiple_respondents === 1
          }));
        } else {
          // fallback default if no questions
          postQuizQuestions = [
            { text: "", options: ["", ""], allowMultiple: false },
            { text: "", options: ["", ""], allowMultiple: false },
            { text: "", options: ["", ""], allowMultiple: false },
          ];
        }


        this.setState({
          pillarId: res.data?.["step-1"]?.pillar_id,
          title: res.data?.["step-1"]?.title || "",
          description: res.data?.["step-1"]?.description || "",
          imgSrc: `${ImageUrl}/${res.data?.["step-1"]?.image}` || "",
          videoTitle: res.data?.["step-2"]?.intro_media_title || "",

          audio_link: res.data?.["step-2"]?.intro_media_type === "mp3" ? res.data?.["step-2"]?.intro_media_link : "",
          selectedLinkOption: res.data?.["step-2"]?.intro_media_type === "mp3" ? 0 : res.data?.["step-2"]?.intro_media_type === "mp4" ? 1 : 0,
          videoUrl: res.data?.["step-2"]?.intro_media_link || "",
          challenge_level: res.data?.["step-2"]?.challenge_level || "",
          challengePointValue: res.data?.["step-2"]?.points || null,
          challengePointKey: res.data?.["step-2"]?.points || "0 points",
          weeksData: weeksData,
          questions: preQuizQuestions,
          feedBackQuestions: postQuizQuestions,
          expandedWeek: 0,

        });

      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error(error)
    }
  }

  saveChallengeDetails = () => {
    const {
      pillarId,
      title,
      description,
      imgSrc,
      videoTitle,
      audio_link,
      videoUrl,
      challenge_level,
      challengePointValue,
      challengeId,
      step1Updated,
      step2Updated,
      step3Updated,
      step4Updated,
      step5Updated,
    } = this.state;
    // this.setState({
    //   buttonstatus: true,
    // });

    this.setState({
      // buttonStatus: true,
      loading: true
    });

    const step3Payload = this.prepareStep3Payload();
    const step4Payload = this.prepareStepFourPayload();
    const step5Payload = this.prepareStepFivePayload();

    const ChallengeData = {
      wellness_challenge_id: parseInt(challengeId, 10),
      step_1_updated: step1Updated,
      step_2_updated: step2Updated,
      step_3_updated: step3Updated,
      step_4_updated: step4Updated,
      step_5_updated: step5Updated,

      "step-1": {
        "pillar_id": pillarId,
        "title": title,
        "description": description,
        "image": imgSrc,
      },
      "step-2": {
        "intro_media_title": videoTitle,
        "intro_media_link": this.state.selectedLinkOption === 0 ? audio_link : videoUrl,
        "intro_media_type": this.state.selectedLinkOption === 0 ? "mp3" : this.state.selectedLinkOption === 1 ? "mp4" : null,
        "challenge_level": challenge_level,
        "points": challengePointValue,
      },
      ...step3Payload,
      ...step4Payload,
      ...step5Payload,
    }

    this.PostEditChallenge(ChallengeData);
  };


  PostEditChallenge = async (payload) => {
    try {
      const res = await fetchApi(EditWellnessChallenge, "PUT", payload);

      if (res?.status === "success") {
        const categoryData = this.props.history.location?.state?.categoryData;

        toast.success(res.data[0]);
        // this.props.history.push({
        //   pathname: `/company/challenges/challenge-category/${challengeId}`,
        //   state: { isWellnessCategory: true }
        // });
        // this.props.history.push({ pathname: "/company/challenges/categories", query: { isWellnessCategory: true } });
        this.props.history.push({ pathname: `/company/challenges/challenge-category/${this.props.history.location?.state?.category_Id}`,state:{...categoryData} })
        this.setState({
          // buttonStatus: true,
          loading: false
        });
      } else {
        toast.error(res.data.message);
        this.setState({

          loading: false
        });

      }
    } catch (error) {
      toast.error(error);
      this.setState({
        loading: false
      });
    }
  }


  handleChange = (index, e) => {
    const newOptions = [...this.state.options];
    newOptions[index] = e.target.value;
    this.setState({ options: newOptions });
  };


  isUrl = (videoUrl) => {
    const UrlRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
    UrlRegex.test(videoUrl);
    if (UrlRegex.test(videoUrl)) {
      this.setState({
        isVideoUrl: true,
        iseventUrlMsg: "",
      });
    } else {
      this.setState({
        isVideoUrl: false,
        iseventUrlMsg: "Please enter valid URL",
      });
    }
  };

  

  toggleWeek = (weekIndex) => {
    this.setState((prevState) => ({
      expandedWeek: prevState.expandedWeek === weekIndex ? null : weekIndex
    }));
  };


  onSelectCategoryType = (selectedItem) => {
    this.setState({
      selectedCategory: selectedItem.month + (selectedItem.month ? " - " : "") + selectedItem.theme_text,
      themeId: selectedItem.month_number,
    });
  };


  onSelectPoints = (name, /*value, key*/) => {
    this.setState({
      [name]: name.value,
      challengePointKey: name.key,
      challengePointValue: name.value,
      step2Updated: true,
    });
  };

  onChangeInputStepOne = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        [e.target.name]: e.target.value,
        step1Updated: true,
      });
    }
  };


  onChangeInput = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        [e.target.name]: e.target.value,
        step2Updated: true,
      });
    }
  };




  onChangeInputStepTwoForm = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        [e.target.name]: e.target.value,
        step2Updated: true,

      });
    }
    if (e.target.name === "videoUrl") {
      this.isUrl(e.target.value);
    }
  };




  onChangeInputDay = (weekIndex, dayIndex, field, value) => {
    this.setState((prevState) => {
      const weeksData = [...prevState.weeksData];
      weeksData[weekIndex][dayIndex] = {
        ...weeksData[weekIndex][dayIndex],
        [field]: value
      };
      return { weeksData, step3Updated: true };

    });
  };


  onChangeURL = (e) => {
    if (e.target.value.charAt(0) !== ' ') {
      this.setState({
        url: e.target.value,
      });
    }
  };

  onChangeTime = (e) => {
    const numValidate = /^[0-9\b]+$/;
    if (e.target.value === "" || numValidate.test(e.target.value)) {
      this.setState({ time: e.target.value });
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };


  onChange = (baseImage, imageName) => {
    this.setState({
      imgSrc: baseImage,
      imageName: imageName,
      step1Updated: true,
    });
  }

  


  onSelectClass = (name, value, key) => {
    const selectedValues = [...this.state[name]];

    if (selectedValues.includes(value)) {
      const index = selectedValues.findIndex((item) => item === value);
      if (index > -1) selectedValues.splice(index, 1);
    } else {
      if (selectedValues.length < 5) {
        selectedValues.push(value);
      }
    }

    this.setState({
      [name]: selectedValues,
      classTypeKey: key,
      coachId: null,
      coachName: '',
    }, () => {
      if (name === "classCategoryTypeValue") {
        this.fetchCoachData(this.state.classCategoryTypeValue);
      }
    });
  };


  eventButtonStatusHover = () => {
    this.setState({
      showBack: true,
    });
  };


  eventButtonStatus = () => {
    this.setState({
      showBack: false,
    });
  };


  prepareStep3Payload = () => {
    const { weeksData } = this.state;



    const tasks = [];

    weeksData.forEach((week, weekIndex) => {
      week.forEach((day, dayIndex) => {
        tasks.push({
          week: weekIndex + 1,
          day: dayIndex + 1,
          task: day.task || "",
          media_link: day.media_type === "mp4" ? day.video_link : day.media_type === "mp3"
            ? day.media_link || null
            : null,
          media_type: day.media_type || "yes-no",
          task_goal: day.goalNotification || "",
          journaling_prompt: day.journalingNotification || "",
          not_completed_notification: day.notCompletedNotification || "",
        });
      });
    });

    return {
      "step-3": {
        tasks: tasks
      }
    };
  };


  prepareStepFourPayload = () => {
    const { questions } = this.state;

    return {
      "step-4": {
        has_pre_quiz: true, // or dynamic if you add a toggle
        pre_quiz_questions: questions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };

  prepareStepFivePayload = () => {
    const { feedBackQuestions } = this.state;
    const validQuestions = feedBackQuestions.filter(
      (q) =>
        q.text.trim() !== "" &&
        q.options.some((opt) => opt.trim() !== "")
    );

    return {
      "step-5": {
        has_post_quiz: validQuestions.length > 0,
        post_quiz_questions: validQuestions.map((q, index) => ({
          question: q.text,
          order: index + 1,
          allow_multiple_respondents: q.allowMultiple,
          answers: q.options
            .filter((opt) => opt.trim() !== "") // remove empty options
            .map((opt) => ({ answer: opt }))
        }))
      }
    };
  };


  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");

    // Determine the actual description value based on your original rules
    const updatedDescription =
      trimmedString.length === 0 ||
        trimmedString.length === 7 ||
        trimmedString === "<p></p><p></p>"
        ? ""
        : newContent;

    // Plain text for character count
    const plainText = newContent.replace(/<[^>]*>/g, "").trim();
    const currentLength = plainText.length;

    this.setState((prevState) => ({
      description: updatedDescription,
      charCount: currentLength,
      step1Updated: updatedDescription !== prevState.description,
    }));
  };





  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
  };

  close = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{ maskType: "alpha", }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  )

  redirect = () => {
    this.props.history.goBack();
  }

  renderHeading = () => {
    const categoryDescription = this.props.history.location?.state?.challengeName || "Edit Challenge";

    return (
      <FormHeading color={"#184A61"}>
        <div className="close-icon" onClick={this.redirect}>
          <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
        </div>
        Edit {categoryDescription} Challenge
      </FormHeading>
    );
  }



  stepOneForm = () => {
    const {
      // title,
      // url,
      description,
      step,
      charCount,
    } = this.state;

    const { t } = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">

              <div className="formBody">

                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Title of the challenge")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Enter challenge title/name")}
                    name="title"
                    onChange={this.onChangeInputStepOne}
                    value={this.state.title}
                    maxLength="30"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                  // disabled
                  />
                  <div className="count">{this.state.title?.length}/30 | C</div>
                </InputContainer>

                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />

                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Challenge image")}{<span>*</span>} <span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadHDMIcon}
                  onImageChange={this.onChange}
                  onRemoveImage={this.removePhoto}
                />
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                <InputContainer isColorError={charCount > 3000 ? true : false}>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("About the challenge")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor content={description} onChange={this.onChangeDescription} />
                  </EditorContainer>
                  <div className="char-count">{charCount}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  toggleRadioButton = (value) => {
    this.setState({ selectedOption: value, step3Updated: true }, () => { });
  };



  toggleLinkRadioButton = (value) => {
    this.setState({ selectedLinkOption: value }, () => { });
  };


  onDropDownSelect = (key, item) => {
    this.setState({
      [key]: item
    });
  };

  onDropDownSelectCoach = (name, id, value) => {
    this.setState({
      [name]: id,
      coachName: value
    });
  };





  onChangeAudioLink = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ Validation
    if ((file.size / 1000000) > 10) {
      return toast.error("Max 10MB");
    }

    if (file.type !== "audio/mpeg") {
      return toast.error("Only MP3 allowed");
    }

    // ✅ Show loader
    this.setState({ audioUploadLoading: true });

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = async () => {
      try {
        const s3Url = await uploadToS3(
          reader.result,
          `wellness/challenges/media`
        );

        if (s3Url?.path) {
          this.setState({
            audio_link: s3Url.path,
            media_type: "mp3",
            audioUploadLoading: false,
          });
        } else {
          this.setState({
            audio_link: "",
            audioUploadLoading: false,
          });
          toast.error("Upload failed");
        }
      } catch (error) {
        console.error(error);
        this.setState({ audioUploadLoading: false });
        toast.error("Something went wrong");
      }
    };
  };

  stepTwoForm = () => {
    const {
      step,
      challengePointValue,
      challengePointKey,
      iseventUrlMsg,
      selectedLinkOption,
      audio_link,
    } = this.state;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" >
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">
              <div className="formBody" >


                <div className="radioButtonDiv" style={{ marginBottom: "12px" }}>
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedLinkOption === 0}
                        onChange={() => this.toggleLinkRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"Upload audio"}</div>
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedLinkOption === 1}
                        onChange={() => this.toggleLinkRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Upload video link"}</div>
                    </div>
                  </RadioButtonWrapper>
                </div>



                {selectedLinkOption === 0 ? audio_link ? (
                  <>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                    <UploadPhotoContainer showBorder={false}>
                      <div className="innerDivImageContainer">
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">
                                {PromotionalDocIcon()}
                              </div>
                              <div>
                                <span className="promotional-doc-name">
                                  Audio uploaded successfully!
                                </span>
                              </div>
                            </div>

                            <div className="main-div" onClick={this.onRemoveAudioLink}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#DA6C74", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      </div>
                    </UploadPhotoContainer>
                  </>
                ) : (
                  <>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                    <AudioUploadBox>
                      <div style={{ marginBottom: "8px" }}>
                        <UploadIconSVG />
                      </div>
                      <div style={{ color: "#184A61", fontWeight: "bold" }}>
                        Upload Audio
                      </div>
                      <div style={{ color: "#666", fontSize: "12px" }}>
                        (.mp3)
                      </div>
                      <input
                        type="file"
                        accept=".mp3,audio/mpeg"
                        onChange={this.onChangeAudioLink}
                      />
                    </AudioUploadBox>
                  </>
                ) : null}



                {selectedLinkOption === 1 ? <>
                  <InputContainer>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video Title")}</StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter title")}
                      name="videoTitle"
                      onChange={this.onChangeInput}
                      value={this.state.videoTitle}
                      maxLength="30"
                      style={{ background: "white" }}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                  </InputContainer>

                  <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                  <InputContainer>
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Introduction Video")}</StyledLabel>
                    <StyledInputV2
                      placeholder={this.props.t("Enter URL")}
                      name="videoUrl"
                      onChange={this.onChangeInput}
                      value={this.state.videoUrl}
                      maxLength="30"
                      style={{ background: "white" }}
                      pColor={"#BDBDBD"}
                      color="#184A61"
                      border={"1px solid #BDBDBD"}
                    />
                    <span style={{ color: "#DA6C74", fontFamily: "Lato", fontSize: '12px' }}>{iseventUrlMsg}</span>
                  </InputContainer>

                </> : null}




                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Challenge Level")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={this.props.t("Level number")}
                    name="challenge_level"
                    onChange={this.onChangeInput}
                    value={`Level ${this.state.challenge_level}`}
                    maxLength="30"
                    style={{ background: "white" }}
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    border={"1px solid #BDBDBD"}
                    disabled
                  />
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />


                <CommonDropdown
                  tileContainerStyle={{ width: "100%", padding: "0px 0px 8px 0px" }}
                  dropdownStyle={{ top: "90px" }}
                  labelText={("Challenge point value")}
                  isSubText={"(per day)"}
                  dropdownOpen={this.state.so}
                  placeholder={("Select Point")}
                  // title={challengePointKey=="0 Points"?"No Points":challengePointKey ? (challengePointKey) : ("Select point")}
                  title={
                    challengePointKey
                  }
                  id="dropdown-recurring"
                  onClick={() => this.setState({ so: !this.state.so })}
                  data={wellnessChallengePoints}
                  onSelect={this.onSelectPoints}
                  active={challengePointValue}
                  itemValue={true}
                  onSelectParameter={["value", "key"]}
                  // onSelectParameter={["month", "id", "theme_icon"]}
                  dropIcon={true}
                  valueIndex={1}
                  labelMargin={"0px"}
                  fontSize={"14px"}
                  isRequired={true}
                />

              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };



  printAction = (bool) => {
    this.setState({ printSampleBiometricCSV: bool });
  }




  handleFiles = (e) => {
    this.setState({
      file: "",
      fileName: "",
      csvUpload: false,
    });

    let file = e.target.files[0];
    if (!file) return;

    const fileName = file?.name;
    let checkCSV = fileName.split(".");
    if (checkCSV[checkCSV.length - 1].toLowerCase() !== "csv") {
      toast.error("Please select .csv format only");
      document.getElementById("csv-upload-input").value = "";
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        file: reader.result ? reader.result : "data:",
        fileName: fileName,
        csvUpload: true,
        step3Updated: true,
        // data: [
        //   { fname: "", lname: "", mail: "" } // initial structure
        // ],
      }, () => {
        // ✅ Once state is set, immediately call your API
        this.PostCsvToJson();
      });
    };
  };


  PostCsvToJson = async () => {
    const { file } = this.state;
    const payload = {
      csv_base64: file,
    };

    try {
      const res = await fetchApi(ConvertCsvToJson, "POST", payload);

      if (res?.status === "success") {
        toast.success(res.data.message);

        const totalRows = res.data.total_rows;
        const data = res.data.data;

        const weeksData = Array.from({ length: 5 }, (_, weekIndex) => {
          const days = weekIndex === 4 ? 3 : 7;

          return Array.from({ length: days }, () => ({
            task: "",
            video_link: "",
            media_type: "",
            media_link: "",
            media_thumbnail: "",
            goalNotification: "",
            journalingNotification: "",
            notCompletedNotification: ""
          }));
        });

        // Fill the weeksData with the JSON values
        data.forEach((item) => {
          const wIndex = item.week - 1;
          const dIndex = item.day - 1;

          if (!weeksData[wIndex] || !weeksData[wIndex][dIndex]) return;

          let mediaType = item?.video_link ? "mp4" : "yes-no";

          let taskValue = (item?.task ?? "").toString().trim();

          weeksData[wIndex][dIndex] = {
            task: taskValue,
            media_type: mediaType,
            video_link: item?.video_link ?? "",
            goalNotification: item?.goal_based_notification ?? "",
            journalingNotification: item?.journaling_prompt_notification ?? "",
            notCompletedNotification: item?.not_completed_notification ?? "",
          };
        });

        if (totalRows < 31) {
          toast.error(
            "Uploaded CSV is incomplete. Please ensure all days(31) of the month are filled before uploading."
          );
          return;
        } else if (totalRows > 31) {
          toast.error(
            "Uploaded CSV data is greater than required data. Please ensure 31 days data are filled before uploading"
          );
          return;
        }

        // ❌ Empty task check
        const hasEmptyTaskEachLine = weeksData.some((week) =>
          week.some((day) => !day.task || day.task.trim() === "")
        );

        if (hasEmptyTaskEachLine) {
          toast.error(
            "Uploaded CSV is incomplete. Please ensure all days of the month are filled before uploading."
          );
        }
        // 🔹 Set state so form auto-fills
        this.setState({ weeksData, expandedWeek: 0 });

        // this.setState({
        //   weeksData: res.data.data, // Assuming the API returns weeksData in the expected format
        //   expandedWeek: 0, 
        // });
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error);
    }
  }



  removeFile = () => {
    // Reset file input field
    const fileInput = document.getElementById('new-employee-file');
    if (fileInput) {
      fileInput.value = '';
    }

    // Reset state
    this.setState({
      csvUpload: false,
      fileName: '',
      file: '',
      step3Updated: true
    });
  };



  onRemoveAudio = async (day) => {
    const url = day?.media_link;
    await deleteFromS3(url);

  }

  getCSVHeaders = () => {
    const csvHeaders = [
      { label: "Week", key: "week" },
      { label: "Day", key: "day" },
      { label: "Task", key: "task" },
      { label: "Video Link", key: "video_link" },
      { label: "Goal Based Notification", key: "goalNotification" },
      { label: "Journaling Prompt Notification", key: "journalingNotification" },
      { label: "Not Completed Notification", key: "notCompletedNotification" },
    ];
    return csvHeaders;
  };


  onChangeAudio = async (e, weekIndex, dayIndex) => {
    const file = e.target.files[0];
    if (!file) return;

    if ((file.size / 1000000) > 10) {
      return toast.error("Max 10MB");
    }

    if (file.type !== "audio/mpeg") {
      return toast.error("Only MP3 allowed");
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = async () => {
      this.setState((prevState) => {
        const weeksData = [...prevState.weeksData];

        weeksData[weekIndex][dayIndex] = {
          ...weeksData[weekIndex][dayIndex],
          audioUploadLoading: true
        };

        return { weeksData };
      });

      const s3Url = await uploadToS3(reader.result, `wellness/challenges/media`);

      if (s3Url?.path) {
        this.onChangeInputDay(weekIndex, dayIndex, "media_link", s3Url?.path, "audioUploadLoading", false);
      } else {
        this.onChangeInputDay(weekIndex, dayIndex, "media_link", null, "audioUploadLoading", false);
      }
    };
  };



  stepThreeForm = () => {

    const {
      step,
      // t,
      // audioName,
      selectedOption,
      // selectedAudioVideoOption,
      fileName,
      csvUpload,
      printSampleBiometricCSV
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">
                  {this.props.t("How would you like to add challenge goal")}{<span>*</span>}
                </StyledLabel>
                <div className="radioButtonDiv">
                  <RadioButtonWrapper isMargin="0px" width gap>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 0}
                        onChange={() => this.toggleRadioButton(0)}
                        value={0}
                        id="1"
                      />
                      <div className="label">{"CSV upload"}</div>
                    </div>
                    <div className="RadioButtonContainer">
                      <RadioButton
                        type={"radio"}
                        checked={selectedOption === 1}
                        onChange={() => this.toggleRadioButton(1)}
                        value={1}
                        id="1"
                      />
                      <div className="label">{"Manual upload"}</div>
                    </div>
                  </RadioButtonWrapper>
                </div>

                {selectedOption === 0 ? <>
                  <Border style={{ background: '#EFEFEF', margin: '4px 0px' }} />
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Add CSV document")}{<span>*</span>}</StyledLabel>
                  <UploadPhotoContainer showBorder={false}>
                    <div className="innerDivImageContainer">
                      {csvUpload ? (
                        <RemoveImageV2>
                          <div className="uploadImage">
                            <div className="promotional-doc">
                              <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                              <div>
                                <span
                                  className="promotional-doc-name"
                                  title={fileName}
                                >
                                  {fileName}
                                </span>
                              </div>
                            </div>
                            <div className="main-div" onClick={this.removeFile}>
                              <div className="icon-div">
                                <div className="sub-icon-div">
                                  {CloseIconBranding("#F37A65", "8", "8")}
                                </div>
                              </div>
                            </div>
                          </div>
                        </RemoveImageV2>
                      ) : (
                        <div className="uploadImage">
                          <InputImage
                            className="edit-profile-pic"
                            imageReload={1}
                            style={{ background: "unset", color: "#184A61" }}
                          >
                            <div
                              className="middle-section"
                              onClick={() => this.csvInputRef.current.click()}
                            >
                              <div>{UploadHDMIcon()}</div>
                              <div className="title">{("Upload File")}</div>
                              <div className="sub-title">{("(.csv)")}</div>
                            </div>
                            <input
                              className="input-section"
                              id="csv-upload-input"
                              type="file"
                              accept=".csv"
                              multiple={false}
                              onChange={this.handleFiles}
                              ref={this.csvInputRef}
                              style={{ display: "none" }}
                            />
                          </InputImage>
                        </div>
                      )}
                    </div>
                  </UploadPhotoContainer>
                </> : null}

                {selectedOption === 0 && !csvUpload ? <ActionButton
                  onClick={() => this.setState({ printSampleBiometricCSV: true })}>
                  Download Sample
                </ActionButton> : null}
                {/* <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} /> */}

                {(csvUpload && selectedOption === 0) || selectedOption === 1 ? <WeekWrapper styel={{ marginTop: "20px" }} isDayText={"16px"}>
                  {this.state.weeksData.map((week, weekIndex) => (
                    <div key={weekIndex}>
                      {/* Week Header */}
                      <WeekContainer onClick={() => this.toggleWeek(weekIndex)} style={{ cursor: "pointer", marginTop: "20px" }}>
                        <div className="weeekText">Week {weekIndex + 1}</div>
                        <div style={{ transform: this.state.expandedWeek === weekIndex ? "rotate(0deg)" : "rotate(180deg)", transition: "transform 0.3s" }}>
                          {WeekDropdownIcon("#DA6C74")}
                        </div>
                      </WeekContainer>


                      {weekIndex !== this.state.weeksData.length - 1 ? (
                        <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                      ) :
                        null
                      }

                      {/* (this.state.expandedWeek === weekIndex && (
                          <Border style={{ background: '#EFEFEF', margin:  '20px 0 8px 0px', display: "flex" }} />
                        )) */}


                      {/* Days - only render if expanded */}
                      {this.state.expandedWeek === weekIndex && week.map((day, dayIndex) => (
                        <React.Fragment key={dayIndex}>

                          {weekIndex === this.state.weeksData.length - 1
                            ? <Border style={{ background: '#EFEFEF', margin: '20px 0px 8px 0px', display: "flex" }} /> : null}
                          <div className="dayText">Day {dayIndex + 1}</div>

                          <InputContainer>
                            <StyledLabel isFont="14px" color="#184A61" margin="0px">
                              {this.props.t("Task")}<span>*</span>
                            </StyledLabel>
                            <StyledInputV3
                              rows={1}
                              placeholder={this.props.t("Enter task")}
                              value={day.task}
                              onChange={(e) => {
                                this.onChangeInputDay(weekIndex, dayIndex, 'task', e.target.value);

                                e.target.style.height = "auto";
                                e.target.style.height = `${e.target.scrollHeight}px`;
                              }}
                              // onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'task', e.target.value)}
                              maxLength="600"
                              style={{ background: "white", overflow: "auto" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                            <div className="count">{day.task.length}/600 | C</div>
                          </InputContainer>

                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />

                          <InputContainer>
                            <StyledLabel margin={"0px"}>{this.props.t("Notification")}  <span className="subtext">(Goal Based Notifiaction)</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              value={day.goalNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'goalNotification', e.target.value)}
                              maxLength="100"
                              style={{ background: "white" }}
                              pColor="#BDBDBD"
                              color="#184A61"
                              border="1px solid #BDBDBD"
                            />
                            <div className="count">{day.goalNotification?.length}/100 | C</div>

                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                          <InputContainer>
                            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Notification")} <span className="subtext">{("(Journaling Prompt)")}</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              name="journalingNotification"
                              value={day.journalingNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'journalingNotification', e.target.value)}
                              maxLength="100"
                              style={{ background: "white" }}
                              pColor={"#BDBDBD"}
                              color="#184A61"
                              border={"1px solid #BDBDBD"}
                            />
                            <div className="count">{day.journalingNotification?.length}/100 | C</div>

                          </InputContainer>
                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />

                          <InputContainer>
                            <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{this.props.t("Notification")} <span className="subtext">{("(If the task is not completed)")}</span></StyledLabel>
                            <StyledInputV2
                              placeholder={this.props.t("Enter notification")}
                              name="videoUrl"
                              value={day.notCompletedNotification}
                              onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'notCompletedNotification', e.target.value)}
                              maxLength="100"
                              style={{ background: "white" }}
                              pColor={"#BDBDBD"}
                              color="#184A61"
                              border={"1px solid #BDBDBD"}
                            />
                            <div className="count">{day.notCompletedNotification?.length}/100 | C</div>

                          </InputContainer>

                          <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />

                          <div className="radioButtonDiv">
                            <RadioButtonWrapper isMargin="0px" gap width={"20%"}>
                              <div className="RadioButtonContainerNew">
                                <RadioButton
                                  type={"radio"}
                                  checked={day.media_type === 'yes-no'}
                                  // onChange={() => this.toggleAudioVideoRadioButton(0)}
                                  value={'yes-no'}
                                  id='yes-no'
                                  // value={day.media_type}
                                  onChange={() => this.onChangeInputDay(weekIndex, dayIndex, 'media_type', 'yes-no')}
                                />
                                <div className="label">{"Yes/No"}</div>
                              </div>
                              <div className="RadioButtonContainerNew">
                                <RadioButton
                                  type={"radio"}
                                  checked={day.media_type === 'mp3'}
                                  // onChange={() => this.toggleAudioVideoRadioButton(1)}
                                  value={'mp3'}
                                  id='mp3'
                                  // value={day.media_type}
                                  onChange={() => this.onChangeInputDay(weekIndex, dayIndex, 'media_type', 'mp3')}
                                />
                                <div className="label">{"Upload audio"}</div>
                              </div>
                              <div className="RadioButtonContainer">
                                <RadioButton
                                  type={"radio"}
                                  checked={day.media_type === 'mp4'}
                                  // onChange={() => this.toggleAudioVideoRadioButton(2)}
                                  value={'mp4'}
                                  id="mp4"
                                  // value={day.video_link}
                                  onChange={() => this.onChangeInputDay(weekIndex, dayIndex, 'media_type', 'mp4')}
                                />
                                <div className="label">{"Upload video link"}</div>
                              </div>
                            </RadioButtonWrapper>
                          </div>

                          {day.media_type === 'mp3' ? <div style={{ display: "flex", gap: "12px", marginTop: "12px" }}>
                            {/* <div>
                              <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Upload Thumbnail")}{<span>*</span>}</StyledLabel>
                              <CommonImageUploaderNew
                                imgSrc={day?.thumbnailUploadLoading ? null : day?.media_thumbnail ? checkBase64(day?.media_thumbnail) ? day?.media_thumbnail : ImageUrl + "/" + day?.media_thumbnail : null}
                                t={t}
                                closeIcon={closeIcon}
                                UploadIcon={UploadHDMIcon}
                                onImageChange={(baseImage,imageName) =>
                                  this.onThumbnailChangeDay(baseImage, imageName,weekIndex, dayIndex)
                                }
                                onRemoveImage={()=>{this.removeThumbnailPhoto(day);this.onChangeInputDay(weekIndex, dayIndex, "media_thumbnail", "");}}
                                isMaxSize={true}
                                loading={day?.thumbnailUploadLoading}
                              />
                            </div> */}
                            <div>
                              <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{this.props.t("Add Audio file")}</StyledLabel>
                              {day?.media_link ? (
                                <UploadPhotoContainer showBorder={false}>
                                  <div className="innerDivImageContainer">
                                    <RemoveImageV2>
                                      <div className="uploadImage">
                                        <div className="promotional-doc">
                                          <div className="promotional-doc-icon">{PromotionalDocIcon()}</div>
                                          <div>
                                            <span
                                              className="promotional-doc-name"
                                            // title={audioName}
                                            >
                                              Audio uploaded successfully!
                                            </span>
                                            {/* <span className="successmsg">Audio uploaded successfully!</span> */}
                                          </div>
                                        </div>
                                        <div className="main-div" onClick={() => { this.onRemoveAudio(day); this.onChangeInputDay(weekIndex, dayIndex, "media_link", ""); }}>
                                          <div className="icon-div">
                                            <div className="sub-icon-div">
                                              {CloseIconBranding("#DA6C74", "8", "8")}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </RemoveImageV2>
                                  </div>
                                </UploadPhotoContainer>
                              ) : (
                                <AudioUploadBox>
                                  {day.audioUploadLoading ? <Spinner color={'#75B084'} /> : <> <div style={{ marginBottom: '8px' }}>
                                    <UploadIconSVG />
                                  </div>
                                  <div style={{ color: '#184A61', fontWeight: 'bold' }}>{('Upload Audio')}</div>
                                  <div style={{ color: '#666', fontSize: '12px' }}>{('(.mp3)')}</div></>}
                                  <input
                                    type="file"
                                    accept=".mp3,audio/mpeg"
                                    onChange={(e) => this.onChangeAudio(e, weekIndex, dayIndex)}
                                  />
                                </AudioUploadBox>
                              )}
                              {/* <div style={{ color: '#184A61', fontSize: '12px', marginBottom: '20px' }}>
                                {('Maximum file size 10 MB')}
                              </div> */}
                            </div>
                          </div> : null}



                          {day.media_type === 'mp4' ?
                            <InputContainer>
                              <StyledLabel isFont="14px" color="#184A61" margin="12px">
                                {this.props.t("Video link")}
                              </StyledLabel>
                              <StyledInputV2
                                placeholder={this.props.t("Enter URL")}
                                value={day.video_link}
                                onChange={(e) => this.onChangeInputDay(weekIndex, dayIndex, 'video_link', e.target.value)}
                                maxLength="30"
                                style={{ background: "white" }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />
                            </InputContainer>
                            : null}



                          {weekIndex !== this.state.weeksData.length - 1 && (
                            <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px', display: "flex" }} />
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                </WeekWrapper> : null}
              </div>
            </div>
          </Container>
        </div>
        {printSampleBiometricCSV && <CSVList Title={`${"Sample file"}`} removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={sampleData} />}
      </Layout>
    )
  }


  handleQuestionChange = (qIndex, e) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].text = e.target.value;
    this.setState({ questions: newQuestions, step4Updated: true });
  };

  handleOptionChange = (qIndex, optionIndex, e) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options[optionIndex] = e.target.value;
    this.setState({ questions: newQuestions, step4Updated: true });
  };

  handleAddOption = (qIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].options.push("");
    
    this.setState({ questions: newQuestions, step4Updated: true });
  };

  toggleSwitch = (qIndex) => {
    const newQuestions = [...this.state.questions];
    newQuestions[qIndex].allowMultiple = !newQuestions[qIndex].allowMultiple;
    this.setState({ questions: newQuestions, step4Updated: true });
  };


  handleFeedBackQuestionChange = (qIndex, e) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].text = e.target.value;
    this.setState({ feedBackQuestions: newQuestions, step5Updated: true });
  };

  handleFeedBackOptionChange = (qIndex, optionIndex, e) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].options[optionIndex] = e.target.value;
    this.setState({ feedBackQuestions: newQuestions, step5Updated: true });
  };

  handleFeedBackAddOption = (qIndex) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].options.push("");
   
    this.setState({ feedBackQuestions: newQuestions, step5Updated: true });
  };

  toggleFeedBackSwitch = (qIndex) => {
    const newQuestions = [...this.state.feedBackQuestions];
    newQuestions[qIndex].allowMultiple = !newQuestions[qIndex].allowMultiple;
    this.setState({ feedBackQuestions: newQuestions, step5Updated: true });
  };


  handleAddQuestion = () => {
    this.setState((prevState) => ({
      questions: [
        ...prevState.questions,
        { text: "", options: ["", ""], allowMultiple: false }
      ],
      activeQuestion: prevState.questions.length, // open newly added
      step4Updated: true
    }));
  };


  // handleRemoveQuestion = (qIndex) => {
  //   this.setState((prevState) => {

  //     const updated = prevState.questions.filter((_, i) => i !== qIndex);
  //     return {
  //       questions: updated,
  //       activeQuestion: null
  //     };
  //   });
  // };



  handleRemoveOption = (qIndex, optionIndex) => {
    this.setState((prevState) => {
      const newQuestions = [...prevState.questions];

      // ❌ minimum 2 options should remain
      if (newQuestions[qIndex].options.length <= 2) {
        return prevState;
      }

      newQuestions[qIndex].options.splice(optionIndex, 1);

      return { questions: newQuestions, step4Updated: true };
    });
  };



  stepFourForm = () => {
    const { step, activeQuestion, questions } = this.state;
    // const optionLabels = ["A", "B", "C", "D", "E"];


    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" isMinHeight={"320px"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>

            <div className="form">
              <StyledLabel
                isFont="18px"
                color="#184A61"
                margin="0px"
                isFloat="none"
                isFontWeight="700"
              >
                {this.props.t("Add question you would like to ask the user before challenge starts")}
              </StyledLabel>

              {/* Loop through questions */}
              {questions.map((q, qIndex) => (
                <div key={qIndex}>
                  {/* Question Header */}
                  <WeekContainer
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        activeQuestion: activeQuestion === qIndex ? null : qIndex,
                      })
                    }
                  >
                    <div className="weeekText">Question {qIndex + 1}</div>

                    {/* <div style={{ display: "flex", gap: "10px" }}> */}
                    {/* Delete */}
                    {/* {questions.length >1 && <div onClick={(e) => {
                        e.stopPropagation();
                        this.handleRemoveQuestion(qIndex);
                      }}>
                        {RecognitionCloseIcon('#DA6C74')}
                      </div>} */}
                    <div
                      style={{
                        transform:
                          activeQuestion === qIndex ? "rotate(0deg)" : "rotate(180deg)",
                        transition: "0.3s",
                      }}
                    >
                      {WeekDropdownIcon("#DA6C74")}
                    </div>
                  </WeekContainer>

                  {qIndex !== questions.length - 1 ? (
                    <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  ) :
                    (activeQuestion === qIndex && (
                      <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    ))}

                  {/* Body only visible if this question is active */}
                  {activeQuestion === qIndex && (
                    <div className="formBody">
                      {/* Question Input */}
                      <InputContainer>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("What would you like to ask?")}<span>*</span>
                        </StyledLabel>
                        <StyledInputV2
                          placeholder={this.props.t("Enter question")}
                          value={q.text}
                          onChange={(e) => this.handleQuestionChange(qIndex, e)}
                          maxLength="150"
                          style={{ background: "white" }}
                          pColor="#BDBDBD"
                          color="#184A61"
                          border="1px solid #BDBDBD"
                        />
                        <div className="count">{q.text.length}/150 | C</div>
                      </InputContainer>

                      <Border
                        style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }}
                      />

                      {/* Options */}
                      <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <StyledLabel isFont="14px" color="#184A61" margin="0px">
                            {this.props.t("Options")}<span>*</span>
                          </StyledLabel>
                          <ToggleContainer>
                            <ToggleWrapper
                              active={q.allowMultiple}
                              onClick={() => this.toggleSwitch(qIndex)}
                            >
                              <ToggleCircle active={q.allowMultiple} />
                            </ToggleWrapper>
                            <div className="respondsText">
                              Allow respondents to select multiple answers
                            </div>
                          </ToggleContainer>
                        </div>



                        {q.options.map((option, index) => (
                          <OptionsContainer
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              width: "100%",
                              marginBottom: "12px",
                            }}
                          >
                            {/* Label A B C */}
                            <div className="questionsText">
                              <div className="questionsNumber">
                                {/* {optionLabels[index]} */}
                                {String.fromCharCode(65 + index)}
                              </div>
                            </div>

                            {/* ✅ Wrapper */}
                            <div style={{ position: "relative", flex: 1 }}>

                              <StyledInputV2
                                placeholder={this.props.t("Add option")}
                                value={option}
                                onChange={(e) => this.handleOptionChange(qIndex, index, e)}
                                maxLength="300"
                                style={{
                                  background: "white",
                                  width: "100%",
                                  paddingRight: q.options.length > 2 && index >= 2 ? "35px" : "12px", // space for icon
                                }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />

                              {/* ✅ Icon INSIDE input */}
                              {q.options.length > 2 && index >= 2 && (
                                <div
                                  onClick={() => this.handleRemoveOption(qIndex, index)}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {RemoveIcon()}
                                </div>
                              )}

                            </div>
                          </OptionsContainer>
                        ))}

                        <MoreOptionText onClick={() => this.handleAddOption(qIndex)}>
                          <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                          <div className="addOptionsText" >
                            Add options
                          </div>
                        </MoreOptionText>

                        {/* {q.options.length < 5 && (
                          <MoreOptionText onClick={() => this.handleAddOption(qIndex)}>
                            <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                            <div className="addOptionsText" >
                              Add options (Max 5)
                            </div>
                          </MoreOptionText>
                        )} */}
                      </div>

                      <Border
                        style={{ background: "#EFEFEF", margin: "8px 0 0 0px" }}
                      />
                    </div>
                  )}
                </div>
              ))}

              <div>
                <MoreOptionText isMargin={"8px 0"} onClick={this.handleAddQuestion}>
                  <div className="icon" style={{ background: "#FCF2F3", borderRadius: "4px" }}>{AddIconRecognition("#DA6C74")}</div>
                  <div
                    className="addOptionsText"

                  >
                    Add Question
                  </div>
                </MoreOptionText>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };


  handleAddFeedBackQuestion = () => {
    this.setState((prevState) => ({
      feedBackQuestions: [
        ...prevState.feedBackQuestions,
        { text: "", options: ["", ""], allowMultiple: false }
      ],
      feedbackActiveQuestion: prevState.feedBackQuestions.length,
      step5Updated: true
    }));
  };


  handleRemoveFeedBackOption = (qIndex, optionIndex) => {
    this.setState((prevState) => {
      const newQuestions = [...prevState.feedBackQuestions];

      if (newQuestions[qIndex].options.length <= 2) {
        return prevState;
      }

      newQuestions[qIndex].options.splice(optionIndex, 1);

      return { feedBackQuestions: newQuestions, step5Updated: true };
    });
  };


  stepFiveForm = () => {
    const {
      step,
      feedBackQuestions,
      feedbackActiveQuestion,
      // levelOpen,
      // challenge_level
    } = this.state;
    // const optionLabels = ["A", "B", "C", "D", "E"];
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87" isMinHeight={"320px"}>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="wellness-challenge-category" />
            </div>
            <div className="form">
              <StyledLabel isFloat="none" isFontWeight="700" isFont="18px" color="#184A61" margin="0px">
                {this.props.t("Add question you would like to ask the user after challenge ends ")} &nbsp;<div className="optText"> {"(Optional)"}</div>
              </StyledLabel>

              {/* <WeekContainer
                style={{ cursor: "pointer", marginBottom: "10px" }}
                onClick={() => this.setState({ levelOpen: !levelOpen })}
              >
                <div className="weeekText">Level {challenge_level}</div>
                <div
                  style={{
                    transform: levelOpen ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "0.3s",
                  }}
                >
                  {WeekDropdownIcon("#DA6C74")}
                </div>
              </WeekContainer> */}
              {/* Loop through questions */}
              {(feedBackQuestions.map((q, qIndex) => (
                <div key={qIndex}>
                  {/* Question Header */}
                  <WeekContainer
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        feedbackActiveQuestion: feedbackActiveQuestion === qIndex ? null : qIndex,
                      })
                    }
                  >
                    <div className="weeekText">Question {qIndex + 1}</div>
                    <div
                      style={{
                        transform:
                          feedbackActiveQuestion === qIndex ? "rotate(0deg)" : "rotate(180deg)",
                        transition: "0.3s",
                      }}
                    >
                      {WeekDropdownIcon("#DA6C74")}
                    </div>
                  </WeekContainer>


                  {qIndex !== feedBackQuestions.length - 1 ? (
                    <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                  ) :
                    (feedbackActiveQuestion === qIndex && (
                      <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />
                    ))}

                  {/* Body only visible if this question is active */}
                  {feedbackActiveQuestion === qIndex && (
                    <div className="formBody">
                      {/* Question Input */}
                      <InputContainer>
                        <StyledLabel isFont="14px" color="#184A61" margin="0px">
                          {this.props.t("What would you like to ask?")}
                        </StyledLabel>
                        <StyledInputV2
                          placeholder={this.props.t("Enter question")}
                          value={q.text}
                          onChange={(e) => this.handleFeedBackQuestionChange(qIndex, e)}
                          maxLength="150"
                          style={{ background: "white" }}
                          pColor="#BDBDBD"
                          color="#184A61"
                          border="1px solid #BDBDBD"
                        />
                        <div className="count">{q.text.length}/150 | C</div>
                      </InputContainer>

                      <Border
                        style={{ background: "#EFEFEF", margin: "20px 0 8px 0px" }}
                      />

                      {/* Options */}
                      <div>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <StyledLabel isFont="14px" color="#184A61" margin="0px">
                            {this.props.t("Options")}
                          </StyledLabel>
                          <ToggleContainer>
                            <ToggleWrapper
                              active={q.allowMultiple}
                              onClick={() => this.toggleFeedBackSwitch(qIndex)}
                            >
                              <ToggleCircle active={q.allowMultiple} />
                            </ToggleWrapper>
                            <div className="respondsText">
                              Allow respondents to select multiple answers
                            </div>
                          </ToggleContainer>
                        </div>

                        {q.options.map((option, index) => (
                          <OptionsContainer
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                              width: "100%",
                              marginBottom: "8px",
                            }}
                          >
                            {/* Label */}
                            <div className="questionsText">
                              <div className="questionsNumber">
                                {/* {optionLabels[index]} */}
                                {String.fromCharCode(65 + index)}
                              </div>
                            </div>

                            {/* ✅ Wrapper (IMPORTANT) */}
                            <div style={{ position: "relative", flex: 1 }}>

                              <StyledInputV2
                                placeholder={this.props.t("Add option")}
                                value={option}
                                onChange={(e) => this.handleFeedBackOptionChange(qIndex, index, e)}
                                maxLength="300"
                                style={{
                                  background: "white",
                                  width: "100%",
                                  paddingRight:
                                    q.options.length > 2 && index >= 2 ? "35px" : "12px",
                                }}
                                pColor="#BDBDBD"
                                color="#184A61"
                                border="1px solid #BDBDBD"
                              />

                              {/* ✅ Icon INSIDE input */}
                              {q.options.length > 2 && index >= 2 && (
                                <div
                                  onClick={() =>
                                    this.handleRemoveFeedBackOption(qIndex, index)
                                  }
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {RemoveIcon()}
                                </div>
                              )}
                            </div>
                          </OptionsContainer>
                        ))}

                        <MoreOptionText onClick={() => this.handleFeedBackAddOption(qIndex)}>
                          <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                          <div className="addOptionsText" >
                            Add options
                          </div>
                        </MoreOptionText>

                        {/* {q.options.length < 5 && (
                          <MoreOptionText onClick={() => this.handleFeedBackAddOption(qIndex)}>
                            <div className="icon">{AddIconRecognition("#DA6C74")}</div>
                            <div className="addOptionsText" >
                              Add options (Max 5)
                            </div>
                          </MoreOptionText>
                        )} */}
                      </div>
                      {/* Toggle */}
                      <Border
                        style={{ background: "#EFEFEF", margin: "8px 0 0 0px" }}
                      />
                    </div>
                  )}
                </div>
              )))}

              <div>
                <MoreOptionText isMargin={"8px 0px"} onClick={this.handleAddFeedBackQuestion}>
                  <div className="icon" style={{ background: "#FCF2F3", borderRadius: "4px" }}>{AddIconRecognition("#DA6C74")}</div>
                  <div
                    className="addOptionsText"
                  >
                    Add Question
                  </div>
                </MoreOptionText>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    )
  }


  // isNextDisabled = () => {
  //   const { weeksData } = this.state;
  //   return weeksData.some((week) =>
  //     week.some((day) => day.prompt.trim() === "" || day.task.trim() === "")
  //   );
  // };



  isNextDisabled = () => {
    const { weeksData } = this.state;

    return weeksData.some((week) =>
      week.some((day) => {
        const task = typeof day.task === "string" ? day.task : "";
        return task.trim() === "";
      })
    );
  };


  isStepFourNextDisabled = () => {
    const { questions } = this.state;
    return questions.some((q) => {
      const filledOptions = q.options.filter((opt) => opt.trim() !== "");
      return filledOptions.length < 2 || q.text.trim() === "";
    });
  };



  isStepFiveNextDisabled = () => {
    const { feedBackQuestions } = this.state;

    return feedBackQuestions.some((q) => {
      const hasQuestion = q.text && q.text.trim() !== "";

      const filledOptions = q.options.filter(
        (opt) => opt && opt.trim() !== ""
      );

      const hasAnyOption = filledOptions.length > 0;

      if (!hasQuestion && !hasAnyOption) {
        return false;
      }

      if (hasQuestion && filledOptions.length < 2) {
        return true;
      }

      if (!hasQuestion && hasAnyOption) {
        return true;
      }

      return false;
    });
  };


  render() {
    const {
      description,
      imgSrc,
      charCount,
      step,
      title,
      challenge_level,
      challengePointValue,
      loading,

    } = this.state;

    if (loading) {
      return <Waiting />;
    }

    const isStep2Disabled = !challengePointValue || !challenge_level;

    return (
      <React.Fragment>
        {step === 1 ? this.stepOneForm() : step === 2 ? this.stepTwoForm() : step === 3 ? this.stepThreeForm() : step === 4 ? this.stepFourForm() : this.stepFiveForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title || !imgSrc || !description || (charCount > 3000)} onClick={!title || !imgSrc || !description || (charCount > 3000) ? null : () => this.updateStep(2)}>
                Next
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"

                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"
                disabled={isStep2Disabled}
                onClick={isStep2Disabled ? null : () => this.updateStep(3)}
              // disabled={!challenge_level || !challengePointValue}
              // onClick={
              //   !challenge_level || !challengePointValue
              //     ? null
              //     : () => this.updateStep(3)
              // }
              // onClick={!buttonstatus ? isEditCategory? () => this.editOndemandEvent() :  () => this.saveOndemandEvent() : null}
              >Next
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) :
          step === 3 ?
            (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(2)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={this.isNextDisabled()} onClick={this.isNextDisabled() ? null : () => this.updateStep(4)}>
                    Next
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            ) : step === 4 ? (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(3)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={this.isStepFourNextDisabled()} onClick={this.isStepFourNextDisabled() ? null : () => this.updateStep(5)}>
                    Next
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            ) : step === 5 && (
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(4)}
                    margin="auto auto auto 0px">
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={this.isStepFiveNextDisabled()} onClick={this.isStepFiveNextDisabled() ? null : () => this.saveChallengeDetails()}   /*onClick={() => this.saveChallengeDetails()}*/ >
                    Save Challenge
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
            )
        }
      </React.Fragment>
    );
  }
}

EditChallengeForm.propTypes = {
  createOndemand: PropTypes.func.isRequired,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
  history: PropTypes.object.isRequired,
  t: PropTypes.func,
  fetchOndemandEventDetailsById: PropTypes.func.isRequired,
  ondemandEventDetail: PropTypes.object,
  isEditCategory: PropTypes.object,
  EditOndemandEventVideo: PropTypes.func,
};





export default (withTranslation()(EditChallengeForm));